import React from 'react'

/**
 * Get status badge component for VAT returns
 * @param {string} value - Status value
 * @param {Function} t - Translation function
 * @returns {JSX.Element} - Status badge component
 */
export const getStatusForVat = (value, t) => {
	let style = {
		display: "inline-block",
		padding: "0px 6px",
		borderRadius: "16px",
		fontWeight: "400",
		fontSize: "12px",
	}

	let textColor = "rgba(71, 71, 71, 1)"

	switch (value) {
		case "new":
			style = { ...style, backgroundColor: "rgba(228, 243, 254, 1)" }
			textColor = "rgba(38, 127, 215, 1)"
			break
		case "submitted":
			style = { ...style, backgroundColor: "rgba(200, 230, 205, 1)" }
			textColor = "rgba(62, 141, 75, 1)"
			break
		case "auto-submitted":
			style = { ...style, backgroundColor: "rgba(200, 230, 205, 1)" }
			textColor = "rgba(62, 141, 75, 1)"
			break
		case "pending":
			style = { ...style, backgroundColor: "rgba(255, 238, 178, 1)" }
			textColor = "rgba(184, 130, 27, 1)"
			break
		case "draft":
			style = { ...style, backgroundColor: "#F4F6F8" }
			textColor = "#637381"
			break
		case "declined":
			style = { ...style, backgroundColor: "rgba(254, 228, 226, 1)" }
			textColor = "rgba(180, 35, 24, 1)"
			break
		case "void":
			style = { ...style, backgroundColor: "rgba(194, 194, 194, 1)" }
			textColor = "rgba(71, 71, 71, 1)"
			break
		default:
			style = { ...style, backgroundColor: "rgba(194, 194, 194, 1)" }
			textColor = "rgba(71, 71, 71, 1)"
			break
	}

	const statusKey = value === "auto-submitted" ? "autoSubmitted" : value
	return (
		<div style={style}>
			<span style={{ color: textColor }}>
				{t(`home.statuses.${statusKey}`, { defaultValue: value })}
			</span>
		</div>
	)
}

/**
 * Sort rows by status (red, yellow priority)
 * @param {Array} rows - Array of row objects
 * @returns {Array} - Sorted rows
 */
export const sortRowsByStatus = (rows) => {
	const statusOrder = { red: 1, yellow: 2 }
	return rows.slice().sort((a, b) => {
		const statusA = a.status.toLowerCase()
		const statusB = b.status.toLowerCase()
		return (
			statusOrder[statusA] - statusOrder[statusB] ||
			statusA.localeCompare(statusB)
		)
	})
}

